import { Routes } from '@angular/router';
import { authGuard } from '@core';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./layouts').then(m => m.MainLayoutComponent),
		canActivate: [authGuard],
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				loadChildren: () =>
					import('./features/dashboard/dashboard.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'fi-goal',
				loadChildren: () =>
					import('./features/fi-profile/fi-profile.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'assets',
				loadChildren: () =>
					import('./features/assets/assets.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'snapshots',
				loadChildren: () =>
					import('./features/snapshots/snapshots.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'goals',
				loadChildren: () =>
					import('./features/goals/goals.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'reminders',
				loadChildren: () =>
					import('./features/reminders/reminders.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'profile',
				loadChildren: () =>
					import('./features/profile/profile.routes').then(
						(m) => m.routes
					),
			},
		]
	},
	{
		path: 'auth',
		loadComponent: () => import('./layouts').then(m => m.AuthLayoutComponent),
		children: [
			{
				path: '',
				loadChildren: () =>
					import('./features/auth/auth.routes').then((m) => m.routes),
			},
		],
	},
	{ path: '**', redirectTo: '' }
];
